import { render, staticRenderFns } from "./ColaboradoresPontosAdminPage.vue?vue&type=template&id=5cf07dcb&scoped=true"
import script from "./ColaboradoresPontosAdminPage.vue?vue&type=script&lang=js"
export * from "./ColaboradoresPontosAdminPage.vue?vue&type=script&lang=js"
import style0 from "./ColaboradoresPontosAdminPage.vue?vue&type=style&index=0&id=5cf07dcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf07dcb",
  null
  
)

export default component.exports